import { render, staticRenderFns } from "./SfColor.vue?vue&type=template&id=01525ac0&functional=true"
import script from "./SfColor.vue?vue&type=script&lang=js"
export * from "./SfColor.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfColor.vue?vue&type=style&index=0&id=01525ac0&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "2fb9afe9"
  
)

export default component.exports